import React from 'react'
import styles from './NextButton.module.css'
import { NextButtonProps } from './types'
import { useStepContext } from '../../../Context/StepContext'

export const NextButton: React.FC<NextButtonProps> = ({
    disabled = false,
    dataClickLabel,
    onClick
}) => {
    const { handleNext } = useStepContext()

    const handleClick = () => {
        if (onClick) {
            onClick()
        } else {
            handleNext()
        }
    }

    return (
        <div className={styles.buttonContainer}>
            <button
                className={styles.nextButton}
                disabled={disabled}
                data-click-label={dataClickLabel}
                onClick={handleClick}
                type='button'
            >
                次へ
                <span className={styles.nextArrow}>＞</span>
            </button>
        </div>
    )
}
